export interface Membership { role: string; status: string; tenant_id: string; store_id?: string }
export interface Store { id: string; tenant_id: string; name: string; currency_code: string | null; time_zone_id: string | null; country_code?: string | null; locale_id?: string | null; currency_source?: string | null; description_text?: string }
export interface Session { user_id: string; tenant_id: string | null; store_id: string | null }
export interface AuthData {
  authenticated: true;
  context_version: string;
  csrf_token: string;
  user: { id: string; full_name: string; username?: string; email?: string; status: string };
  session: Session;
  store_member: Membership | null;
  organization_member: Membership | null;
  store: Store;
}
export type SessionResult = AuthData | { authenticated: false; csrf_token: string };
export interface Verification { challenge_id: string; email_masked: string; email_sent?: boolean; resend_after_seconds?: number; retry_after_seconds?: number; expires_in_seconds?: number; attempts_left?: number }
export const isActiveOwner = (member: Membership | null) => member?.role === 'owner' && member.status === 'active';
